import { ICoords } from '../common';

// TODO rename this and merge with IAddress??
export interface IStopAddress {
  company: string;
  street: string;
  extraLine?: string;
  city: string;
  postalCode: string;
  stateCode: string;
  countryCode: string;
  coords?: ICoords;
  phone?: string;
  taxId?: string;
  addressbookId?: number | string;
  // state and country are displayed using translations
}

export function getEmptyIStopAddress(): IStopAddress {
  return {
    company: '',
    street: '',
    city: '',
    postalCode: '',
    stateCode: '',
    countryCode: '',
    // state and country are displayed using translations
  };
}
